import React from 'react';
import { Text, Button } from 'v3/components';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import { styles } from '../styles';

export default function QuestionsFooter({
  answered,
  answeredCount,
  canRetryTraining,
  certificateUrl,
  handleBackToIdentification,
  handleBackToVideoReview,
  handleRetryTraining,
  handleSubmit,
  identificationLocked,
  isMobile,
  locked,
  saving,
  total,
  uniqueLock,
  watchOnlyVideoQuestionItem,
}) {
  return (
    <div style={styles.footer(isMobile)}>
      <div style={styles.leftFooter(isMobile)}>
        {answered ? (
          <div style={styles.missing}>
            {canRetryTraining
              ? 'Certificado não liberado. Escolha como deseja tentar novamente.'
              : certificateUrl
              ? 'Certificado disponível para download.'
              : 'Checklist respondido.'}
          </div>
        ) : (
          <div style={styles.missing}>
            Faltam {total - answeredCount} pergunta(s)
          </div>
        )}
      </div>

      <div style={styles.rightFooter(isMobile)}>
        {!answered && !watchOnlyVideoQuestionItem && (
          <Button
            onClick={handleBackToIdentification}
            disabled={locked}
            outlined
            style={styles.footerSecondaryButton(isMobile)}
          >
            <Text type="small" weight={800}>
              Voltar para Identificação
            </Text>
          </Button>
        )}

        {((!answered && identificationLocked && watchOnlyVideoQuestionItem) ||
          (canRetryTraining && watchOnlyVideoQuestionItem)) && (
          <Button
            onClick={handleBackToVideoReview}
            disabled={canRetryTraining ? saving || uniqueLock.blocked : locked}
            outlined
            style={styles.footerSecondaryButton(isMobile)}
          >
            <Text type="small" weight={800}>
              Rever vídeo
            </Text>
          </Button>
        )}

        <Button
          onClick={canRetryTraining ? handleRetryTraining : handleSubmit}
          disabled={
            canRetryTraining
              ? saving || uniqueLock.blocked
              : locked || total === 0 || answered || uniqueLock.blocked
          }
          loading={saving}
          style={styles.footerPrimaryButton(isMobile)}
        >
          <div style={styles.footerPrimaryContent}>
            {canRetryTraining ? (
              <PlayArrowRoundedIcon style={{ fontSize: 18 }} />
            ) : answered ? (
              <CheckCircleOutlineIcon style={{ fontSize: 18 }} />
            ) : (
              <SendOutlinedIcon style={{ fontSize: 18 }} />
            )}

            <Text type="small" weight={800}>
              {canRetryTraining
                ? 'Responder novamente'
                : answered
                ? 'Respondido'
                : 'Responder'}
            </Text>
          </div>
        </Button>
      </div>
    </div>
  );
}
